<template>
  <div id="profile-page">
    <!-- PROFILE HEADER -->
    <div class="profile-header profile-header-nav p-6">
      <div class="flex items-center justify-between flex-wrap">
        <span class="text-lg font-medium">{{ match.title }}（{{ match.type == 1?'个人赛':'团队赛' }}）</span><span></span>
        <vs-button type="gradient" icon-pack="feather" icon="icon-arrow-right-circle" icon-after :href="match.url" :target="true">前往赛事页面</vs-button>
      </div>
      <vs-divider/>
      <vx-card class="overflow-hidden" style="box-shadow: 0 0 black !important" title="评分规则" collapse-action>
        <div v-html="schedule.rule"></div>
      </vx-card>
    </div>

    <div class="items-grid-view vx-row match-height mt-base" v-if="list.length" appear>
      <div class="vx-col lg:w-1/5 md:w-1/3 sm:w-1/2 w-full" v-for="item in list" :key="item.objectID" :title="item.title">
        <item-grid-work-view :item="item">
            <template slot="action-buttons">
                <div class="flex flex-wrap">
                    <!-- PRIMARY BUTTON : REMOVE -->
                    <div
                        class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                        @click="showWorkVideo(item)">
                        <feather-icon icon="VideoIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2">视频</span>
                    </div>

                    <div
                        v-if="!match.isScratch"
                        class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                        @click="downloadWork(item)">
                        <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2">作品</span>
                    </div>

                    <div
                        v-else
                        class="item-view-secondary-action-btn p-3 flex flex-grow items-center justify-center  cursor-pointer"
                        @click="goToScratch(item)">
                        <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2">作品</span>
                    </div>

                    <div
                        class="item-view-secondary-action-btn p-3 flex flex-grow items-center justify-center  cursor-pointer"
                        @click="showScorePanel(item)">
                        <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />

                        <span v-if="!item.score" class="ml-2">评分</span>
                        <span v-else class="ml-2">修改评分</span>
                    </div>

                </div>
            </template>
        </item-grid-work-view>
      </div>
    </div>

    <vs-prompt
      vs-title="作品视频"
      vs-accept-text="完成"
      vs-cancel-text="关闭"
      :vs-active.sync="activePrompt"
    >
      <h4>{{ currentWork.fileName }}</h4>
      <video-player v-if="currentWork.video" ref="player" class="media-video-player mb-4" :options="playerOptions(setMedia(currentWork.video))" />
      <p class="mt-4 text-center" v-else>作者未上传视频</p>
    </vs-prompt>
    <vs-prompt
      vs-title="作品评分"
      vs-accept-text="提交"
      vs-cancel-text="取消"
      :vs-active.sync="activeScorePrompt"
      @vs-accept="submitWorkScore"
    >
      <div style="white-space: nowrap;">
        <h4>{{ currentWork.fileName }}</h4>
        <div class="flex justify-between mt-2">
          <span class="text-lg self-center">创新创造：</span>
          <vs-slider color="warning" max=20 icon="star" v-model="grade[0]" />
        </div>
        <div class="flex mt-2">
          <span class="text-lg self-center">构思设计：</span>
          <vs-slider color="danger" max=20 icon="star" v-model="grade[1]" />
        </div>
        <div class="flex mt-2">
          <span class="text-lg self-center">艺术审美：</span>
          <vs-slider color="success" max=20 icon="star" v-model="grade[2]" />
        </div>
        <div class="flex mt-2">
          <span class="text-lg self-center">程序设计：</span>
          <vs-slider  max=20 icon="star" v-model="grade[3]" />
        </div>
        <div class="flex mt-2">
          <span class="text-lg self-center">视频讲解：</span>
          <vs-slider color="success" max=20 icon="star" v-model="grade[4]" />
        </div>
        <div class="flex mt-2">
          <span class="text-lg self-center">最终得分：</span>
          <!-- <span>{{ currentWork.score }}</span> -->
          <span>{{ computedGrade }}</span>
        </div>
      </div>
      
      <vs-collapse>
        <vs-collapse-item>
          <div slot="header">
            其他
          </div>
            <div class="flex mt-2">
              <span class="text-lg w-32">评分图片：</span>
              <upload-image :url="currentWork.images"  @url="getImgUrl"></upload-image>
            </div>
            <div class="flex mt-2">
              <span class="text-lg text-right w-32">备注：</span>
              <vs-textarea class="w-1/2" counter="100" :counter-danger.sync="counterDanger" v-model="currentWork.remark" />
            </div>
        </vs-collapse-item>
      </vs-collapse>
      
    </vs-prompt>
  </div>
</template>

<script>

import UploadImage from '@/components/upload/UploadImage'

import { teamList, workScore } from '@/api/match'
import { getToken } from '@/utils/tools'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import config from '@/config'

const ItemGridWorkView = () => import("./components/ItemGridWorkView.vue");

export default {
  data() {
    return {
      match: {
        id: 0,
        title: '',
        type: 0,
        isScratch: 0,
      },
      schedule: {
        id: 0,
        name: '',
        rule: '',
      },
      list: [],
      currentWork: false,
      activePrompt: false,
      activeScorePrompt: false,
      mediaExtensions: { img: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'exif', 'tiff'], video: ['avi', 'flv', 'wmv', 'mov', 'mp4', '3gp'] },
      media: { sources: [{ type: "video/mp4", src: "http://vjs.zencdn.net/v/oceans.mp4" }]},
      counterDanger: false,
      grade: [0,0,0,0,0],
    };
  },
  computed: {
    playerOptions() {
      return (media) => {
          return {
              height: '360',
              fluid: true,
              autoplay: false,
              muted: true,
              language: 'en',
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: media.sources,
          }
      }
    },
    computedGrade() {
      return this.grade.reduce((a, b) => { return a + b})
    }
  },
  methods: {
    setMedia(src) {
      this.media.sources[0].src = src
      return this.media
    },
    openLoading(type) {
      if (type) {
        this.$vs.loading({
          text:'努力加载中...'
        })
      } else {
        this.$vs.loading.close()
      }
    },
    showWorkVideo(item) {
      this.currentWork = item
      this.activePrompt = true
    },
    showScorePanel(item) {
      this.currentWork = item
      this.grade = [0,0,0,0,0]
      this.activeScorePrompt = true
    },
    goToScratch(item) {
      // 设置当前团队及赛程到工具端，方便获取
      localStorage.setItem('currentSid', this.schedule.id) // 设置赛程id
      localStorage.setItem('currentTid', item.teamId) // 设置团队id
      localStorage.setItem('currentWid', item.workId)
      window.open(`${config.matchHost}scratch/?grade#${item.workId}`)
    },
    downloadWork(item) {
      let that = this
      that.$http.get(item.fileSrc, { responseType: 'blob'}).then(res => {
        if (!res.data) {
          that.$vs.notify({
            title:'下载失败',
            text: '作品不存在！',
            color:'error',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          })
          return
        }
        let url = window.URL.createObjectURL(new Blob([res.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', `${item.fileName}.${item.fileSrc.substring(item.fileSrc.lastIndexOf('.') + 1)}`)

        document.body.appendChild(link)
        link.click()
        // 释放资源及移除节点（用完就丢）
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
      }).catch(err => {
        console.log('err:', err)
      })
    },
    getTeamList() {
      let that = this
      teamList({
        access_token: getToken(),
        matchId: that.match.id,
        scheduleId: that.schedule.id,
      }).then((res) => {
        if (res.data.err_code === 0) {
          that.match = res.data.match
          that.schedule.rule = res.data.rules
          that.list = res.data.list.sort(function(a, b){
            if (a.gradeStatus === b.gradeStatus) {
              return b.score - a.score
            } else {
              return b.gradeStatus - a.gradeStatus
            }
          })
          that.openLoading(false)
        } else {
          that.$router.push('/pages/error-404')
        }
        
      })
    },
    getImgUrl(path) {
      this.currentWork.images = path
    },
    submitWorkScore() {
      let that = this
      that.currentWork.score = that.computedGrade
      workScore({
        access_token: getToken(),
        scheduleId: that.schedule.id,
        teamId: that.currentWork.teamId,
        workId: that.currentWork.workId,
        score: that.currentWork.score,
        images: that.currentWork.images,
        remark: that.currentWork.remark,
      }).then(res => {
        if (res.data.err_code === 0) {
          that.$vs.notify({
            title:'评分成功',
            text: '评分成功！',
            color:'success',
            iconPack: 'feather',
            icon:'icon-alert-circle'
          })
        }
      })
    }
  },
  components: {
    UploadImage,
    videoPlayer,
    ItemGridWorkView,
  },
  created() {
    this.match.id = this.$route.query.matchId
    this.schedule.id = this.$route.query.scheduleId
    this.openLoading(true)
    this.getTeamList()
  },
  mounted() {
  },
  updated() {
  }
};
</script>

<style>
#profile-page .profile-header-nav {
    background-color: #fff;
}

</style>
